import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import DemoBanner from "./DemoBanner";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Sidebar />
      <main className="lg:ml-72 min-h-screen pt-20 pb-8 px-4 sm:px-6 lg:p-12 flex flex-col gap-6 lg:gap-8">
        <DemoBanner />
        <Outlet />
      </main>
    </div>
  );
}
